import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TickerCardComponent } from '../ticker-card/ticker-card.component';

@Component({
  selector: 'dk-revenue-total-ticker',
  templateUrl: 'revenue-total-ticker.component.html',
  standalone: true,
  imports: [CommonModule, TickerCardComponent],
})
export class RevenueTotalTickerComponent {
  @Input() data: any = null;
}
